import React, {useEffect, useRef} from 'react';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';
import {
  CardContainerDesktop,
  CardsWrapper,
  VerticalAligned,
} from './ui/id-mirror-cards-styles';
import {getIdMirrorCards} from './utils/get-id-mirror-cards';

export const IdMirrorCards = () => {
  const {registerRefs} = useIdMirrorTheme();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const darkRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];
  const lightRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          registerRefs({
            cardsWrapper: wrapperRef.current,
            cardsContentDark: darkRefs
              .map((r) => r.current)
              .filter(Boolean) as HTMLDivElement[],
            cardsContentLight: lightRefs
              .map((r) => r.current)
              .filter(Boolean) as HTMLDivElement[],
          });
        } else {
          registerRefs({
            cardsWrapper: null,
            cardsContentDark: null,
            cardsContentLight: null,
          });
        }
      },
      {threshold: 0.1},
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const cards = getIdMirrorCards(darkRefs, lightRefs);

  return (
    <CardsWrapper ref={wrapperRef} className="cards-wrapper-desktop">
      {cards.map((card, i) => (
        <VerticalAligned key={i} i={i}>
          <CardContainerDesktop className="card-container-desktop">
            {card}
          </CardContainerDesktop>
        </VerticalAligned>
      ))}
    </CardsWrapper>
  );
};
